/**
 * capitalize a string.
 * @param str
 * @returns
 */
export const capitalize = (str = '') => {
  return str
    ?.toLowerCase()
    ?.replace(/(\b[a-z](?!\s))/g, (letter) => letter?.toUpperCase());
};

export const capitalizeText = (str: string) => {
  return capitalize(str || '');
};
